<template>
    <section class="filters__taxonomies__grid mb-4">
        <div v-for="taxonomy in taxonomies" class="filters__taxonomies__flex">
            <input type="checkbox" :id="taxonomy.slug" :value="taxonomy.slug" v-model="selectedTaxonomies">
            <label :for="taxonomy.slug">{{ taxonomyTitle(taxonomy) }}</label>
        </div>
    </section>
</template>

<script>
export default {
    inject: ['locale'],
    emits: ['update:modelValue'],
    props: {
        modelValue: {type: Array, default: []},
        content: {type: Array, required: true},
        taxonomies: {type: Array, required: true}
    },
    data: () => ({
        selectedTaxonomies: [],
    }),
    beforeMount() {
        this.value = [...this.content]
    },
    methods: {
        taxonomyTitle(taxonomy) {
            return taxonomy?.multi[this.locale]
        },
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value){
                this.$emit('update:modelValue', value)
            }
        }
    },
    watch: {
        selectedTaxonomies: {
            handler(newValue){
                if(newValue.length === 0) return this.value = this.content

                this.value = this.content.filter(item => {
                    let taxonomies = item.taxonomies || []
                    return taxonomies.some(taxonomy => newValue.includes(taxonomy.slug))
                })
            },
            deep:true
        }
    }
}
</script>
<style scoped lang="scss">
@media screen and (max-width: 991px) {

  .filters__taxonomies__grid {
    display: grid;
    justify-content: center;
    grid-template-columns: repeat(3, minmax(0, max-content)) !important;
    grid-template-rows: auto;
    gap: 10px !important;
    grid-auto-columns: max-content;
  }

  .filters__taxonomies__flex:last-child {
    grid-column: span 3;
  }
}

@media screen and (max-width: 575px) {
  .filters__taxonomies__grid {
    display: grid;
    justify-content: center;
    grid-template-columns: repeat(3, minmax(0, max-content)) !important;
    grid-template-rows: auto;
    gap: 10px !important;
    grid-auto-columns: max-content;
  }

  .filters__taxonomies__flex:last-child {
    grid-column: span 3;
  }
}

.filters__taxonomies__grid {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, minmax(0, max-content));
  grid-template-rows: auto;
  gap: 20px;
  grid-auto-columns: max-content;
}

.filters__taxonomies__flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  input[type="checkbox"] {
    display: none;
  }

  label {
    min-width: 100px;
    cursor: pointer;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 3px;
    padding-top: 3px;
    background-color: transparent;
    border: 1px solid #9C9C9C;
    border-radius: 2rem;
    font-size: 15px;
    font-weight: normal;
    text-align: center;
    color: #ACACAC;
    -webkit-user-select: none; /* Safari */
    -ms-user-select: none; /* IE 10 and IE 11 */
    user-select: none; /* Standard syntax */
  }

  input[type="checkbox"]:checked + label {
    background-color: #4196CD;
    border-color: #73FFEB;
    color: white;
    font-weight: 600;
  }
}


</style>